import { splitUrlText } from '@/shared/lib/splitUrlText';
import * as s from './LinkifiedText.css';

export function LinkifiedText({ text }: { readonly text: string }) {
  return splitUrlText(text).map((part) => {
    switch (part.kind) {
      case 'text':
        return part.text;
      case 'link':
        return (
          <a
            key={part.start}
            href={part.text}
            target="_blank"
            rel="noopener noreferrer"
            className={s.link}
            onClick={(event) => event.stopPropagation()}
          >
            {part.text}
          </a>
        );
      default: {
        const exhaustive: never = part.kind;
        return exhaustive;
      }
    }
  });
}
